import { createContext, useContext, useState, ReactNode } from 'react'

interface VersionContextType {
  version: string
  setVersion: (version: string) => void
}

const VersionContext = createContext<VersionContextType | undefined>(undefined)

export function VersionProvider({ children }: { children: ReactNode }) {
  const [version, setVersion] = useState('latest')

  return <VersionContext.Provider value={{ version, setVersion }}>{children}</VersionContext.Provider>
}

export function useVersion() {
  const context = useContext(VersionContext)
  if (!context) {
    throw new Error('useVersion must be used within VersionProvider')
  }
  return context
}
